import { observer } from 'src/utils/mobx-react';
import { Popup } from 'src/components/Popup/Popup';
import React, { useState } from 'react';
import { AppState, useAppStateContext } from 'src/AppState/AppState';
import { action, observable, makeAutoObservable } from 'mobx';
import { Resource } from 'src_common/common/mobx-utils/Resource';
import { CreateMarketForm } from 'src/domains/sportsbook/trading/view/eventDetails/markets/createMarketModal/CreateMarketForm';
import { PossibleMarketsType } from 'src/AppState/sdk/staff';
import { ArrayElement } from './CreateMarketForm.state';
import { EventId } from 'src_common/common/websocket2/id/WebsocketId';

class CreateMarketModalState {
    @observable public markets: Resource<PossibleMarketsType>;

    public constructor(
        private readonly props: CreateMarketModalPropsType,
        private readonly appState: AppState
    ) {
        this.markets = new Resource(async (): Promise<PossibleMarketsType> => {
            return await this.appState.sdkStaff.staff_event_possible_markets({
                event_id: this.props.eventId.toOldId(),
            });
        });
        makeAutoObservable(this);
    }

    @action public add = async (data: {
        templateId: string;
        params: ArrayElement<PossibleMarketsType> | null;
    }): Promise<void> => {
        // TODO - add selectedLine to types and request after rewrite for gateway
        const selectedLine =
            //@ts-expect-error
            // eslint-disable-next-line no-negated-condition
            data.params.selectedLine !== undefined ? parseFloat(Object.values(data.params.selectedLine)[0]) : undefined;
        const eventId = await this.props.eventId.idv2();

        if (data.params === null) {
            this.appState.reduxAction.addError(`Error creating market for event ${this.props.eventId.toOldId()}`);
        } else {
            const { matchingMarkets, metadata, name, requiredParameters } = data.params;
            const result = await this.appState.sdkStaff.createMarketForEvent({
                event_id: eventId,
                template_id:
                    data.params.id === null || data.params.id === undefined
                        ? 'new-trading-dGhlLWJlc3Q='
                        : data.params.id.toLowerCase(),
                requestBody: {
                    matchingMarkets,
                    metadata,
                    name,
                    requiredParameters,
                    selectedLine,
                },
            });

            if (result.status === 'ok') {
                this.props.onClose();
            } else {
                if (result.message.includes('already exists')) {
                    this.appState.reduxAction.addError('Market already exists');
                } else {
                    this.appState.reduxAction.addError(
                        `Error creating market for event ${this.props.eventId.toOldId()}`
                    );
                }
            }
        }
    };
}

interface CreateMarketModalPropsType {
    eventId: EventId;
    active: boolean;
    onClose: () => void;
    onFinish: () => void;
}

export const CreateMarketModal = observer('CreateMarketModal', (props: CreateMarketModalPropsType) => {
    const appState = useAppStateContext();
    const [state] = useState(() => new CreateMarketModalState(props, appState));
    const markets = state.markets.get();

    return (
        <Popup
            title='Add market'
            className='create-market-modal'
            priority={1000}
            active={props.active}
            onClose={props.onClose}
        >
            <CreateMarketForm
                markets={markets.type === 'ready' ? markets.value : []}
                onSubmit={state.add}
                eventId={props.eventId}
            />
        </Popup>
    );
});
